import React, { lazy } from 'react'
import { RouteWithoutLayout } from './Route/RouteWithoutLayout'
import { CommonPages } from 'components/_pages/common'
import { AnyRoleRouteWithLayout } from './Route/AnyRole/AnyRoleRouteWithLayout'
import { RouteWithLayout } from './Route/RouteWithLayout'
import { Redirect, Route, Switch } from 'react-router-dom'
import { LoginRoute } from './Route/LoginRoute'
import { AuthPages } from 'components/_pages/auth'
import { PolicyPages } from 'components/_pages/policy'
import { useAppUser } from 'components/_hooks'
import { getIsOrganizer, getIsPlayer } from 'store/types/user-types'
const AdminRoutes = lazy(() => import('./AdminRoutes'))
const FaqRoutes = lazy(() => import('./FaqRoutes'))
const PlayerRoutes = lazy(() => import('./PlayerRoutes'))
const OrganizerRoutes = lazy(() => import('./OrganizerRoutes'))

const CommonRoutes = () => {
  const appUser = useAppUser()
  const isAnonymous = !appUser
  const isPlayer = !isAnonymous && getIsPlayer(appUser?.Role)
  const isOrganizer = !isAnonymous && getIsOrganizer(appUser?.Role)
  return (
    <Switch>
      <Route path="/admin" component={AdminRoutes} />
      <Route path="/faq" component={FaqRoutes} />
      <RouteWithLayout contentMaxWidth exact path="/" component={CommonPages.HomeNew} />
      <RouteWithLayout oldCss exact path="/tickets/ticket/:ticketId" component={url => <CommonPages.TournamentTicket ticketId={url.match.params.ticketId} />} />
      <RouteWithLayout exact path="/game-detail/:gameId/:tab?" component={CommonPages.GameTournaments} />
      <RouteWithLayout oldCss exact path="/tournament-detail/:tournamentId/:tab?" component={CommonPages.TournamentDetailsPage} />
      <RouteWithLayout oldCss exact path="/public-profile-view/:organizerId" component={CommonPages.PublicProfileView} />
      <RouteWithLayout exact contentMaxWidth path="/player/:userId?" component={CommonPages.PlayerPage} />
      <RouteWithLayout exact path="/player/:userId/friends" component={CommonPages.FriendsPage} />
      <RouteWithLayout exact path="/user/:userId/review" component={CommonPages.UserReview} />
      <RouteWithLayout exact path="/rules" component={CommonPages.Rules} />
      <RouteWithLayout exact path="/disclaimer" component={CommonPages.Disclaimer} />
      <RouteWithLayout exact path="/news" component={CommonPages.NewsList} />
      <RouteWithLayout exact path="/news/:id/:title?" component={CommonPages.News} />
      <RouteWithLayout oldCss exact path="/games" component={CommonPages.Games} />
      <RouteWithLayout exact path="/tournaments/:tab?" component={CommonPages.Tournaments} />
      <RouteWithLayout oldCss exact path="/victory-road-map" component={CommonPages.VictoryRoadMap} />
      <RouteWithLayout exact path="/victory-road-list/:id?" component={CommonPages.VictoryRoadList} />
      <RouteWithLayout exact path="/clan/:clanId?" component={CommonPages.ClanPage} />

      <RouteWithoutLayout exact path="/victory-road/bracket/:tournamentDetailId" component={CommonPages.VictoryBracket} />
      <RouteWithoutLayout exact path="/tournament-bracket/:tournamentDetailId" component={CommonPages.TournamentBracketPage} />

      <AnyRoleRouteWithLayout exact path="/members/:tab?" component={CommonPages.MembersPage} />

      <RouteWithoutLayout oldCss exact path="/privacy-policy" component={PolicyPages.PrivacyPolicy} />
      <RouteWithoutLayout oldCss exact path="/terms-of-service" component={PolicyPages.TermsOfService} />
      <RouteWithoutLayout oldCss exact path="/privacy-policy/:section" component={url => <PolicyPages.PrivacyPolicy section={url.match.params.section} />} />

      <LoginRoute oldCss exact path="/login" component={AuthPages.Login} />
      <LoginRoute exact path="/register" component={AuthPages.SignUp} />
      <LoginRoute oldCss exact path="/register/success" component={AuthPages.RegisterSuccess} />
      <RouteWithoutLayout oldCss exact path="/password-recovery" component={AuthPages.PasswordRecovery} />
      <RouteWithoutLayout oldCss exact path="/activate/:hash" component={AuthPages.Activate} />
      <Route exact path="/404">
        <Redirect to="/" />
        </Route>
      {!isOrganizer && <PlayerRoutes />}
      {!isPlayer && <OrganizerRoutes />}
      <Route>
        <Redirect to="/404" />
      </Route>
    </Switch>
  )
}

export default CommonRoutes
